import {http} from './config/config-receituario'
export default{
    listar:(token)=>{
        return http.get('tipo_conta',{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, tipoConta)=>{
        return http.post('tipo_conta', tipoConta,{
            headers:{
                'Authorization':token
            }
        })
    }, 
    atualizarTipoConta:(token, tipoConta) =>{
        return http.put('tipo_conta/'+tipoConta.id,tipoConta,{
            headers:{
                'Authorization':token
            }
        })
    }, 
    deleteTipoConta:(token, id)=>{
        return http.delete('tipo_conta/'+id,{
            headers:{
                'Authorization':token
            }
        })
    }
}